import React from 'react'
import {Box,TextInput, Form, FormField} from 'grommet'
import {Notes,DocumentCloud} from 'grommet-icons';
import {RequestButton} from './utils/shared/shipmentViewFunctions'

function CreateOrgForm (props) {
  return ( 
    <Form value={props.value} onSubmit={props.handleSubmit} onChange={nextValue => props.handleChange(nextValue)}>
    <Box direction='row' justify="center" flex="grow" margin={{top: 'large'}}>
        <FormField required label='Organisation Name' name='name' margin='small' >
            <TextInput icon={<Notes />} name='name' placeholder="Enter Organisation Name" />
        </FormField>
        <FormField required label='Organisation Markup' name='markup' margin='small' >
            <TextInput icon={<Notes />} name='markup' type='number' placeholder="Enter Organisation Markup" />
        </FormField>
        <FormField label='Logo' margin='small' >
            <TextInput icon={<DocumentCloud/>}type="file" onChange={props.handleDocsChange} />
        </FormField>
    </Box>
    <Box direction='row' justify="center" margin={{top: 'medium'}}>
        <RequestButton load={props.load} label={"Create Organisation"} />
    </Box>
   </Form>

  )
}

export default CreateOrgForm
